import React, { Component } from 'react';

//styles
import './topSection.scss';

import '../../static/fonts/opensanshebrew/stylesheet.css'
import '../../static/fonts/NarkisBlockCondensed/style.css'
import { VirtualPageview, Prof, Uri } from '../Analytics/Analytics'
import { scrollDown } from '../../static/scrollAnimation'

class TopSection extends Component {
    componentDidMount() {
        VirtualPageview(Uri + Prof);
    }

    render() {
        return (
            <div className="section1-container">
                <div className="desc-container">
                    <div className="title">
                        נושאי הדגל
                </div>
                    <div className="desc">האנשים שמאחורי המאבקים הבולטים  של קהילת הלהט"ב בישראל חוזרים לרגעי הייאוש והשפל, מספרים על פריצות הדרך החשובות ומקווים לעתיד ורוד יותר. פרויקט מיוחד
                <br /><div>עריכת תוכן וריאיונות: לורי שטטמאור, הפקה: מיכאלה חזני, תחקיר: עדי ברמן</div>
                    </div>
                </div>
                <div className="down-arrow" onClick={scrollDown}></div>

            </div>
        );
    }
}

export default TopSection;


// WEBPACK FOOTER //
// ./src/Components/TopSection/TopSection.js